import { AccountantService, TaxProfileService, TaxSlipYearService } from "../../../services";
import { BackdropCircularProgress, EnhancedSnackbar } from "@websential/cosmic";
import { IDropDownListResponse, IGetListRequest } from "../../../models";
import { INITIAL_PAGE_SIZE, INITIAL_SNACKBAR_DATA } from "../../../common/constants";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { setSelectedAccountant, setSelectedAccountantName, setSelectedClient, setSelectedClientName } from "../../../store/actions";

import { Grid } from "@mui/material";
import { Link } from "react-router-dom";
import { ReportsService } from "../../../services/ReportsService";
import { TransactionsReportDataTable } from "./PrimeDataGrid";
import { setSelectedActivityLogActions } from "../../../store/actions/activityLogActions";
import { setSelectedStickyNavBar } from "../../../store/actions/stickyNavBarActions";
import { useDispatch } from "react-redux";
import { useQuery } from "@tanstack/react-query";

export interface ITransactionsReport { }

const useTransactionsReport = (
  params: IGetListRequest
) =>
  useQuery({
    queryKey: ["Transaction-report-list", params],
    queryFn: (data) => {
      return ReportsService.getAdminTransactionsReport(params);
    },
    refetchOnWindowFocus: false
  });

const useGetAccountantsDropDownList = () =>
  useQuery({
    queryKey: ["get-accountant-dll"],
    queryFn: () => { return TaxProfileService.getAccountantsDropDownList() },
    refetchOnWindowFocus: false
  });
const useYears = (params: IGetListRequest) =>
  useQuery({
    queryKey: ["years-list", params],
    queryFn: (data) => {
      return TaxSlipYearService.getList(params);
    },
    refetchOnWindowFocus: false
  });

export const TransactionsReport: React.FC<ITransactionsReport> = () => {
  const dispatch = useDispatch();
  const [isLoadingList, setIsLoadingList] = useState(false);
  const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
  const onSnackbarClosed = (
    event: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarData(INITIAL_SNACKBAR_DATA);
  };

  const {
    isLoading: isLoadingYearsList,
    data: yearsDDLList,
    // refetch: refetchTabsDDL,
  } = useYears({
    search_query: "",
    order_by: "client_name",
    order_direction: "asc",
    page: 1,
    size: 25,
  });

//   const highestSavedYear = yearsDDLList && yearsDDLList.items.reduce(
//   (max:any, cur:any) => (cur.year > max.year ? cur : max),
//   yearsDDLList.items[0]
// );
const highestYear = yearsDDLList && yearsDDLList.items ? Math.max(...(yearsDDLList.items?.map((d:any) => d.year) ?? [])) : null

  // console.log('highestSavedYear',highestSavedYear)
  console.log('highestYear',highestYear)

  const [queryParams, setQueryParams] = useState<any>({
    search_query: "",
    order_by: "client_name",
    order_direction: "asc",
    page: 1,
    size: 25,
    accountantselected: "All",
    invoiceselected: 400,
    yearselected: highestYear,
  });

  useEffect(()=>{
    if(highestYear){
      setQueryParams((prevParams: any) => ({
      ...prevParams,
      yearselected: highestYear,
    }));
    }
  },[highestYear])

  const { isLoading, data: transactionReport } = useTransactionsReport(queryParams);
  const transactionReportList: any = transactionReport;


  const {
    isLoading: isLoadingAccountantDropDownList,
    data: accountantDDLList,
    // refetch: refetchTabsDDL,
  } = useGetAccountantsDropDownList();


  const yearsDDLItems = useMemo(() => {
    if (yearsDDLList && Array.isArray(yearsDDLList && yearsDDLList.items)) {
      return (
        yearsDDLList &&
        yearsDDLList.items.map((year: any) => ({
          id: year.id,
          label: year.year,
          value: year.year,
        }))
      );
    }

    // Return empty array in case of API data fetching error
    return [];
  }, [yearsDDLList]);


  const accountantDDLItems = useMemo(() => {
    if (accountantDDLList && Array.isArray(accountantDDLList)) {
      let resources: IDropDownListResponse[] = accountantDDLList.map(
        (resourceItem: IDropDownListResponse) => ({
          id: resourceItem.id,
          label: resourceItem.label,
          value: resourceItem.value,
        })
      );

      resources.unshift({
        label: "--All Accountants--",
        value: "All",
      });
      return resources;
    }

    return [
      {
        label: "--All Accountants--",
        value: "All",
      },
    ];
  }, [accountantDDLList]);



  const onRequestParamsChange = useCallback((requestParams: any) => {

    let dispatchParams = {
      search_query: requestParams.searchQuery ? requestParams.searchQuery : "",
      order_by: "client_name",
      order_direction: "asc",
      page: requestParams.page + 1,
      size: requestParams.rows,
      accountantselected: requestParams.accountantselected,
      invoiceselected: requestParams.invoiceselected,
      yearselected: requestParams.yearselected,
    };


    setQueryParams(dispatchParams);
  }, []);



  let data = {
    "page": 1,
    "size": 50,
    "total": 3,
    "items": [
      {
        "clientId": "64be1e04-7e13-4aea-8af5-1ac5325ea239",
        "clientName": "12343",
        "accountantId": "64be1e04-7e13-4aea-8af5-1ac5325ea239",
        "t4TotalSlip": 4,
        "rl1TotalSlip": 2,
        "t4aTotalSlip": 0,
        "t4TotalSummary": 0,
        "rl1TotalSummary": 1,
        "t4aTotalSummary": 0,
        "duplicationExist": "No"
      },
      {
        "clientId": "48f866b2-f3a1-4248-b6c6-1523511c8605",
        "clientName": "after live",
        "accountantId": "f3193f46-dd18-4a99-8d71-68300fba1b2f",
        "t4TotalSlip": 2,
        "rl1TotalSlip": 1,
        "t4aTotalSlip": 1,
        "t4TotalSummary": 0,
        "rl1TotalSummary": 1,
        "t4aTotalSummary": 0,
        "duplicationExist": "No"
      },
      {
        "clientId": "c8c79f95-90fa-4d32-b3ec-5bee22414909",
        "clientName": "T222",
        "accountantId": "f3193f46-dd18-4a99-8d71-68300fba1b2f",
        "t4TotalSlip": 4,
        "rl1TotalSlip": 2,
        "t4aTotalSlip": 2,
        "t4TotalSummary": 1,
        "rl1TotalSummary": 0,
        "t4aTotalSummary": 0,
        "duplicationExist": "No"
      }
    ],
    "keyField": {
      "field": "client_name",
      "templateUrl": "/taxslip/client/setup/id"
    },
    "headerColumns": [
      {
        "field": "clientName",
        "headerName": "Client Name",
        "description": "Client Name",
        "flex": 1,
        "hide": false,
        "hideable": false,
        "sortable": true,
        "sortingOrder": "asc",
        "resizable": false,
        "type": "string",
        "align": "left",
        "headerAlign": "left",
        "hideSortIcons": false,
        "disableColumnMenu": true,
        "disableReorder": true,
        "disableExport": true,
        "maskable": false,
        "isFixed": true,
        "sequence": 0,
        "frozenColumn": false,
        "footer": "Total"
      },
      {
        "field": "t4TotalSlip",
        "headerName": "T4",
        "description": "T4",
        "flex": 1,
        "hide": false,
        "hideable": false,
        "sortable": true,
        "sortingOrder": "asc",
        "resizable": false,
        "type": "string",
        "align": "left",
        "headerAlign": "left",
        "hideSortIcons": false,
        "disableColumnMenu": true,
        "disableReorder": true,
        "disableExport": true,
        "maskable": false,
        "isFixed": true,
        "sequence": 1,
        "frozenColumn": false,
        "footer": 10
      },
      {
        "field": "t4TotalSummary",
        "headerName": "T4 Summary",
        "description": "T4 Summary",
        "flex": 1,
        "hide": false,
        "hideable": false,
        "sortable": true,
        "sortingOrder": "asc",
        "resizable": false,
        "type": "string",
        "align": "left",
        "headerAlign": "left",
        "hideSortIcons": false,
        "disableColumnMenu": true,
        "disableReorder": true,
        "disableExport": true,
        "maskable": false,
        "isFixed": true,
        "sequence": 2,
        "frozenColumn": false,
        "footer": 1
      },
      {
        "field": "rl1TotalSlip",
        "headerName": "RL-1",
        "description": "RL-1",
        "flex": 1,
        "hide": false,
        "hideable": false,
        "sortable": true,
        "sortingOrder": "asc",
        "resizable": false,
        "type": "string",
        "align": "left",
        "headerAlign": "left",
        "hideSortIcons": false,
        "disableColumnMenu": true,
        "disableReorder": true,
        "disableExport": true,
        "maskable": false,
        "isFixed": true,
        "sequence": 3,
        "frozenColumn": false,
        "footer": 5
      },
      {
        "field": "rl1TotalSummary",
        "headerName": "RL-1 Summary",
        "description": "RL-1 Summary",
        "flex": 1,
        "hide": false,
        "hideable": false,
        "sortable": true,
        "sortingOrder": "asc",
        "resizable": false,
        "type": "string",
        "align": "left",
        "headerAlign": "left",
        "hideSortIcons": false,
        "disableColumnMenu": true,
        "disableReorder": true,
        "disableExport": true,
        "maskable": false,
        "isFixed": true,
        "sequence": 4,
        "frozenColumn": false,
        "footer": 2
      },
      {
        "field": "t4aTotalSlip",
        "headerName": "T4A",
        "description": "T4A",
        "flex": 1,
        "hide": false,
        "hideable": false,
        "sortable": true,
        "sortingOrder": "asc",
        "resizable": false,
        "type": "string",
        "align": "left",
        "headerAlign": "left",
        "hideSortIcons": false,
        "disableColumnMenu": true,
        "disableReorder": true,
        "disableExport": true,
        "maskable": false,
        "isFixed": true,
        "sequence": 5,
        "frozenColumn": false,
        "footer": 3
      },
      {
        "field": "t4aTotalSummary",
        "headerName": "T4A Summary",
        "description": "T4A Summary",
        "flex": 1,
        "hide": false,
        "hideable": false,
        "sortable": true,
        "sortingOrder": "asc",
        "resizable": false,
        "type": "string",
        "align": "left",
        "headerAlign": "left",
        "hideSortIcons": false,
        "disableColumnMenu": true,
        "disableReorder": true,
        "disableExport": true,
        "maskable": false,
        "isFixed": true,
        "sequence": 6,
        "frozenColumn": false,
        "footer": 0
      },
      {
        "field": "duplicationExist",
        "headerName": "Duplication Exist",
        "description": "Duplication Exist",
        "flex": 1,
        "hide": false,
        "hideable": false,
        "sortable": true,
        "sortingOrder": "asc",
        "resizable": false,
        "type": "string",
        "align": "left",
        "headerAlign": "left",
        "hideSortIcons": false,
        "disableColumnMenu": true,
        "disableReorder": true,
        "disableExport": true,
        "maskable": false,
        "isFixed": true,
        "sequence": 7,
        "frozenColumn": false,
        "footer": null
      }
    ]
  }
  const onClientClickHandler = async (clickedRow: any) => {

    //get accountant titile 
    // try {
    //   const response = await AccountantService.getById(clickedRow.accountantId);

    dispatch(setSelectedAccountantName({ accTitle: clickedRow.accTitle }));
    // } catch (err) {

    // }
    dispatch(setSelectedAccountant({ id: clickedRow.accountantId }));
    dispatch(setSelectedClient({ id: clickedRow.clientId }));
    dispatch(setSelectedClientName({ clientName: clickedRow.clientName }));
  };

  const sortedItems = transactionReport && transactionReport?.items.toSorted((a: any, b: any) => a.clientName.localeCompare(b.clientName));
  const updatedRowsWithClientNavigation = transactionReport && sortedItems && sortedItems.map((row: any) => {
    return {
      ...row,
      clientName: (
        <Link
          to={"/clients/dashboard"}
          className="no-underline"
          style={{ color: "blue" }}
          onClick={() => onClientClickHandler(row)}
        >
          {row.clientName}
        </Link>
      ),
    };
  });


  useEffect(() => {
    dispatch(
      setSelectedActivityLogActions({
        entityId1: "",
        entityId2: "",
        entityId3: "",
        screenName: '',
        companyName: '',
        activityType:
          "",
        activityLogVisibility: false,
      })
    );
    dispatch(setSelectedStickyNavBar({ isSticky: false }));
  }, []);

  return (
    <Grid
      size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
      sx={{ width: "100%", overflow: "hidden" }}
    >
      <BackdropCircularProgress open={false} testId="TransactionsReport" />
      <TransactionsReportDataTable
        rows={transactionReport && updatedRowsWithClientNavigation}
        columns={transactionReport ? transactionReport?.headerColumns : []}
        showIndexColumn={true}
        initialPageSize={INITIAL_PAGE_SIZE}
        totalRecords={transactionReport ? transactionReport.total : 0}
        onRequestParamsChange={onRequestParamsChange}
        accountantDDLList={accountantDDLItems}
        yearsDDL={yearsDDLItems}
        // onRowDeleteClicked={onRowDeleteClicked}
        isLoading={isLoading}
        highestYear={highestYear}
      />
      <EnhancedSnackbar
        message={snackbarData.message}
        onCloseHandler={onSnackbarClosed}
        severity={snackbarData.severity}
        testId={`TransactionsReport-snackbar`}
        open={snackbarData.open}
      />
    </Grid>
  );
};
